import { useEffect } from 'react';
import LandingNav from '../landing/LandingNav';
import LandingFooter from '../landing/LandingFooter';
import TermlyEmbed from './TermlyEmbed';
import styles from './LegalLayout.module.css';

// Shared shell for the Termly-backed legal pages (privacy / terms / cookies).
export default function LegalLayout({ title, dataId }) {
  useEffect(() => {
    document.getElementById('top')?.scrollTo({ top: 0 });
  }, []);

  return (
    <div id="top" className={styles.page}>
      <LandingNav />
      <main>
        <section className={styles.header}>
          <span className={styles.eyebrow}>Legal</span>
          <h1 className={styles.title}>{title}</h1>
          <p className={styles.note}>
            The current version, with its last-updated date, is shown below.
          </p>
        </section>

        <section className={styles.docSection}>
          {/* Light document surface keeps the provider-rendered text readable on the dark site */}
          <div className={styles.doc}>
            <TermlyEmbed dataId={dataId} />
          </div>
        </section>
      </main>
      <LandingFooter />
    </div>
  );
}
